'use client';

import Script from 'next/script';

const EVERVIZ_ID_REGEX = /\/share\/([A-Za-z0-9_-]+)(?:\/|$)/;

interface EvervizEmbedProps {
  url: string;
  className?: string;
}

function extractEvervizId(url: string): string {
  const match = EVERVIZ_ID_REGEX.exec(url);
  if (!match || !match[1]) {
    throw new Error(`Invalid Everviz share URL: ${url}`);
  }
  return match[1];
}

const EvervizEmbed = ({ url, className }: EvervizEmbedProps) => {
  try {
    const id = extractEvervizId(url);
    if (!id) return null;

    return (
      <div id={`everviz-${id}`} className={`everviz-${id} ${className}`}>
        <Script
          id={`everviz-${id}`}
          src={`https://app.everviz.com/inject/${id}/?v=7`}
          strategy="lazyOnload"
        />
      </div>
    );
  } catch (error) {
    console.error('Error extracting Everviz ID:', error);
    return null;
  }
};

export default EvervizEmbed;